// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto+Mono:300,400|Rubik:900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*/
/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/
*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}
::before,
::after {
  --tw-content: '';
}
/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/
html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}
/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/
body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}
/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/
hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}
/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/
abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}
/*
Remove the default font size and weight for headings.
*/
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}
/*
Reset links to optimize for opt-in styling instead of opt-out.
*/
a {
  color: inherit;
  text-decoration: inherit;
}
/*
Add the correct font weight in Edge and Safari.
*/
b,
strong {
  font-weight: bolder;
}
/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/
code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}
/*
Add the correct font size in all browsers.
*/
small {
  font-size: 80%;
}
/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/
table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}
/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/
button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}
/*
Remove the inheritance of text transform in Edge and Firefox.
*/
button,
select {
  text-transform: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/
button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}
/*
Use the modern Firefox focus style for all focusable elements.
*/
:-moz-focusring {
  outline: auto;
}
/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/
:-moz-ui-invalid {
  box-shadow: none;
}
/*
Add the correct vertical alignment in Chrome and Firefox.
*/
progress {
  vertical-align: baseline;
}
/*
Correct the cursor style of increment and decrement buttons in Safari.
*/
::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}
/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/
[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}
/*
Remove the inner padding in Chrome and Safari on macOS.
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/
::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}
/*
Add the correct display in Chrome and Safari.
*/
summary {
  display: list-item;
}
/*
Removes the default spacing and border for appropriate elements.
*/
blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}
fieldset {
  margin: 0;
  padding: 0;
}
legend {
  padding: 0;
}
ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}
/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}
/*
Prevent resizing textareas horizontally by default.
*/
textarea {
  resize: vertical;
}
/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/
input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}
/*
Set the default cursor for buttons.
*/
button,
[role="button"] {
  cursor: pointer;
}
/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}
/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/
img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}
/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/
img,
video {
  max-width: 100%;
  height: auto;
}
/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.relative{
  position: relative;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.mb-12{
  margin-bottom: 3rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.ml-0\\.5{
  margin-left: 0.125rem;
}
.mr-2\\.5{
  margin-right: 0.625rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.inline-block{
  display: inline-block;
}
.flex{
  display: flex;
}
.grid{
  display: grid;
}
.h-auto{
  height: auto;
}
.w-4\\/5{
  width: 80%;
}
.max-w-6xl{
  max-width: 72rem;
}
.max-w-\\[2000px\\]{
  max-width: 2000px;
}
.max-w-md{
  max-width: 28rem;
}
.flex-\\[2\\]{
  flex: 2 1;
}
.flex-\\[3\\]{
  flex: 3 1;
}
.flex-col{
  flex-direction: column;
}
.flex-wrap{
  flex-wrap: wrap;
}
.items-center{
  align-items: center;
}
.gap-2{
  gap: 0.5rem;
}
.gap-8{
  gap: 2rem;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-xl{
  border-radius: 0.75rem;
}
.border{
  border-width: 1px;
}
.border-gray-200{
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-gray-700{
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
}
.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-gray-100{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-800{
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}
.bg-gray-900{
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-gradient-to-b{
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.from-\\[\\#c0dfd9\\]{
  --tw-gradient-from: #c0dfd9 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(192 223 217 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white{
  --tw-gradient-from: #fff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-white{
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #fff var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-\\[\\#c0dfd9\\]{
  --tw-gradient-to: #c0dfd9 var(--tw-gradient-to-position);
}
.to-white{
  --tw-gradient-to: #fff var(--tw-gradient-to-position);
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.px-10{
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-24{
  padding-top: 6rem;
  padding-bottom: 6rem;
}
.text-center{
  text-align: center;
}
.align-top{
  vertical-align: top;
}
.font-\\[\\'Roboto_Mono\\'\\]{
  font-family: 'Roboto Mono';
}
.font-\\[\\'Rubik\\'\\]{
  font-family: 'Rubik';
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.font-black{
  font-weight: 900;
}
.font-bold{
  font-weight: 700;
}
.leading-relaxed{
  line-height: 1.625;
}
.text-\\[\\#3b3a36\\]{
  --tw-text-opacity: 1;
  color: rgb(59 58 54 / var(--tw-text-opacity, 1));
}
.text-\\[\\#f7f7f7\\]{
  --tw-text-opacity: 1;
  color: rgb(247 247 247 / var(--tw-text-opacity, 1));
}
.shadow-\\[0px_5px_10px_\\#b3c2bf\\]{
  --tw-shadow: 0px 5px 10px #b3c2bf;
  --tw-shadow-colored: 0px 5px 10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[5px_4px_10px_\\#f7f7f7\\]{
  --tw-shadow: 5px 4px 10px #f7f7f7;
  --tw-shadow-colored: 5px 4px 10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[5px_4px_10px_rgba\\(247\\2c 247\\2c 247\\2c 0\\.1\\)\\]{
  --tw-shadow: 5px 4px 10px rgba(247,247,247,0.1);
  --tw-shadow-colored: 5px 4px 10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.grayscale{
  --tw-grayscale: grayscale(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
@keyframes glowing {
  from {
    text-shadow: -1px 0px 3px rgba(255, 255, 255, 0.4);
  }
  to {
    text-shadow: -1px 0px 6px rgba(255, 255, 255, 0.8);
  }
}
body {
  margin: 0 auto;
  width: 100%;
  height: 100%;
  background-color: #2b2b2b;
}

section {
  position: relative;
  max-width: 2000px;
  margin: 0 auto;
}

button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

.App.light {
  background: #fff;
}

.down-arrow {
  position: absolute;
  font-size: 46px;
  left: 48%;
  transform: translateX(-50%);
  bottom: 4px;
}

.intro {
  position: relative;
  width: 100%;
  height: 100vh;
  background: #000;
}
.intro .down-arrow {
  color: white;
}
.intro h1 {
  position: relative;
  color: white;
  font-family: "Rubik", sans-serif;
  font-weight: 900;
  font-size: 55px;
  margin: 0px;
  animation: glowing;
  animation-duration: 1s;
  animation-delay: 2s;
  animation-direction: alternate;
  animation-iteration-count: infinite;
}
.intro h2 {
  position: relative;
  color: white;
  font-family: "Roboto Mono", monospace;
  margin: 5px auto;
  font-size: 25px;
}

#cta_links a {
  display: inline-block;
  margin-right: 10px;
  margin-left: 2px;
  color: #3b3a36;
  font-size: 30px;
  transition: transform 0.3s;
  will-change: transform;
}
#cta_links a:hover {
  transform: scale(1.1);
}
#cta_links svg {
  vertical-align: top;
}

.arrow-container {
  -webkit-animation-delay: 5s;
  clear: both;
}

section.intro {
  display: flex;
  align-items: center;
  justify-content: center;
}
section.intro .text-wrapper {
  text-align: center;
}
section.intro .img-wrapper {
  padding: 0 0 0 80px;
}
section.intro .img-wrapper > img {
  opacity: 1;
  width: 180px;
  height: auto;
}

section.skills {
  padding-top: 10vh;
  position: relative;
  background: #fff;
}
section.skills .down-arrow {
  color: #3b3a36;
}
section.skills h1 {
  color: #3b3a36;
  font-family: "Rubik", sans-serif;
  font-weight: 900;
  text-align: center;
  padding-bottom: 20px;
}

.skill {
  background-color: #c0dfd9;
  color: #fff;
  font-family: "Roboto Mono", monospace;
  display: inline-block;
  padding: 11px 20px;
  margin: 4px 4px;
  border-radius: 15px;
  box-shadow: 0px 3px 5px #b3c2bf;
  float: left;
}

.skills ul {
  width: 65%;
  height: 65vh;
  margin: 0 auto;
  padding-left: 5%;
}

section.projects {
  position: relative;
  background: #fff;
  padding: 0 0 40px 0;
}
section.projects h1 {
  margin: 0 auto;
  color: #3b3a36;
  font-family: "Rubik", sans-serif;
  font-weight: 900;
  text-align: center;
  text-shadow: 4px 4px 4px #e9ece5;
  font-size: 65px;
}
section.projects > h1 {
  padding: 40px 0;
}

.project-container {
  position: relative;
  opacity: 0;
  transform: scale(0);
  transition: all 1s;
}

.project-container.in {
  opacity: 1;
  transform: scale(1);
}

.project-section {
  display: flex;
  width: 100%;
  margin: 0 auto;
  padding: 60px 40px 85px 40px;
  box-sizing: border-box;
}
.project-section .left {
  flex: 2 1;
  display: flex;
  align-items: center;
}
.project-section .left img {
  width: 100%;
  height: auto;
  max-height: 100%;
  border-radius: 10px;
  border: 1px solid rgba(233, 236, 229, 0.4);
  box-shadow: 0px 4px 4px #e9ece5;
}
.project-section .left .imageWrapper {
  text-align: center;
}
.project-section .left .imageWrapper img {
  width: 100%;
  height: auto;
  background-color: white;
}
.project-section .right {
  flex: 3 1;
}
.project-section .right h1 {
  color: #3b3a36;
  font-family: "Rubik", sans-serif;
  font-size: 45px;
  font-weight: bold;
  text-align: center;
  text-shadow: 4px 4px 4px #e9ece5;
}
.project-section .right p {
  text-align: center;
  font-family: "Roboto Mono", monospace;
  color: #3b3a36;
  width: 90%;
  margin: 0 auto;
  padding: 10px 0;
  line-height: 1.4em;
}

ul.skills {
  width: 100%;
  margin: 0 auto;
  padding: 10px 0;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  list-style: none;
}
ul.skills > li {
  padding: 5px 15px;
  background-color: #c0dfd9;
  color: #fff;
  font-family: "Roboto Mono", monospace;
  padding: 7px 15px;
  margin: 4px 4px;
  border-radius: 15px;
  white-space: nowrap;
  box-shadow: 0px 3px 5px #b3c2bf;
}

.links {
  display: block;
  text-align: center;
}
.links a {
  color: #3b3a36;
  display: inline-block;
  padding: 10px;
  font-size: 40px;
  text-align: center;
  transition: transform 0.3s;
  will-change: transform;
}
.links a:hover {
  transform: scale(1.1);
}

button.dark-mode-toggle {
  position: fixed;
  height: 35px;
  width: 35px;
  bottom: 15px;
  right: 15px;
  padding: 0;
  margin: 0 auto;
  border: none;
  outline: none;
  background: none;
  border-radius: 50%;
}

button.dark-mode-toggle.light {
  color: #000;
}

button.dark-mode-toggle.dark {
  color: #fff;
}

button.dark-mode-toggle svg {
  position: absolute;
  top: 0px;
  left: 0px;
  height: 100%;
  width: 100%;
  padding: 7px;
  box-sizing: border-box;
}

@media screen and (max-width: 900px) {
  .project-section {
    flex-direction: column;
    padding: 30px 40px;
  }
  .project-section .left img {
    max-width: 620px;
    margin: 0 auto;
  }
  .project-section .right {
    flex: 1 1;
    padding: 30px 0 0 0;
  }
  section.intro {
    flex-direction: column-reverse;
  }
  section.intro .img-wrapper {
    padding: 0 0 20px 0;
  }
  ul.skills {
    width: 100%;
    display: flex;
    justify-content: center;
  }
}
@media screen and (max-width: 480px) {
  section.projects h1 {
    font-size: 3em;
  }
  .project-section {
    padding: 30px 20px;
  }
  .project-section .right h1 {
    font-size: 2em;
  }
}
.App.dark {
  background: #000;
}
.App.dark section.intro .img-wrapper {
  opacity: 0.1;
}
.App.dark .arrow-container {
  display: none;
}
.App.dark section.projects {
  background: #000;
}
.App.dark section.projects h1 {
  color: #f7f7f7;
  text-shadow: 4px 4px 4px #3b3b3b;
}
.App.dark section.projects p,
.App.dark section.projects a {
  color: #f7f7f7;
}
.App.dark section.projects ul.skills > li {
  background: #000;
  box-shadow: 0px 0px 8px #f7f7f7;
}
.App.dark section.projects .left img {
  box-shadow: -2px 4px 15px #f7f7f7;
}
@media (min-width: 768px){
  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (min-width: 1024px){
  .lg\\:max-w-none{
    max-width: none;
  }
  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .lg\\:flex-row{
    flex-direction: row;
  }
  .lg\\:items-center{
    align-items: center;
  }
  .lg\\:text-left{
    text-align: left;
  }
  .lg\\:text-5xl{
    font-size: 3rem;
    line-height: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.scss"],"names":[],"mappings":"AACA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;;CAAA;AAAA;;;CAAA;AAAA;;;EAAA,sBAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,mBAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;AAAA;;EAAA,gBAAA;AAAA;AAAA;;;;;;;;CAAA;AAAA;;EAAA,gBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA,EAAA,MAAA;EAAA,WAAA,EAAA,MAAA;EAAA,+HAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,wCAAA,EAAA,MAAA;AAAA;AAAA;;;CAAA;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;AAAA;;;;CAAA;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,yCAAA;UAAA,iCAAA;AAAA;AAAA;;CAAA;AAAA;;;;;;EAAA,kBAAA;EAAA,oBAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,cAAA;EAAA,wBAAA;AAAA;AAAA;;CAAA;AAAA;;EAAA,mBAAA;AAAA;AAAA;;;;;CAAA;AAAA;;;;EAAA,+GAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,cAAA;AAAA;AAAA;;CAAA;AAAA;;EAAA,cAAA;EAAA,cAAA;EAAA,kBAAA;EAAA,wBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,WAAA;AAAA;AAAA;;;;CAAA;AAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;EAAA,yBAAA,EAAA,MAAA;AAAA;AAAA;;;;CAAA;AAAA;;;;;EAAA,oBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA;EAAA,gCAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,uBAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,SAAA,EAAA,MAAA;EAAA,UAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;;EAAA,oBAAA;AAAA;AAAA;;;CAAA;AAAA;;;;EAAA,0BAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,aAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,wBAAA;AAAA;AAAA;;CAAA;AAAA;;EAAA,YAAA;AAAA;AAAA;;;CAAA;AAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,wBAAA;AAAA;AAAA;;;CAAA;AAAA;EAAA,0BAAA,EAAA,MAAA;EAAA,aAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;;CAAA;AAAA;;;;;;;;;;;;;EAAA,SAAA;AAAA;AAAA;EAAA,SAAA;EAAA,UAAA;AAAA;AAAA;EAAA,UAAA;AAAA;AAAA;;;EAAA,gBAAA;EAAA,SAAA;EAAA,UAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,UAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;;;CAAA;AAAA;;EAAA,UAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;;EAAA,eAAA;AAAA;AAAA;;CAAA;AAAA;EAAA,eAAA;AAAA;AAAA;;;;CAAA;AAAA;;;;;;;;EAAA,cAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;AAAA;;CAAA;AAAA;;EAAA,eAAA;EAAA,YAAA;AAAA;AAAA,wEAAA;AAAA;EAAA,aAAA;AAAA;AAEA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,qEAAA;EAAA;AAAA;AAAA;EAAA,yDAAA;EAAA,qEAAA;EAAA;AAAA;AAAA;EAAA,sEAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,+CAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,wJAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAEA;EACE;IACE,kDAAA;EAAF;EAEA;IACE,kDAAA;EAAF;AACF;AAEA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;AAAF;;AAEA;EACE,kBAAA;EACA,iBAAA;EACA,cAAA;AACF;;AACA;;EAEE,SAAA;EACA,UAAA;AAEF;;AACA;EACE,gBAAA;AAEF;;AACA;EACE,kBAAA;EACA,eAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;AAEF;;AAAA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;AAGF;AAFE;EACE,YAAA;AAIJ;AAFE;EACE,kBAAA;EACA,YAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;EACA,mCAAA;AAIJ;AAFE;EACE,kBAAA;EACA,YAAA;EACA,qCAAA;EACA,gBAAA;EACA,eAAA;AAIJ;;AAAE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,0BAAA;EACA,sBAAA;AAGJ;AAFI;EACE,qBAAA;AAIN;AADE;EACE,mBAAA;AAGJ;;AAAA;EACE,2BAAA;EACA,WAAA;AAGF;;AADA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAIF;AAHE;EACE,kBAAA;AAKJ;AAHE;EACE,mBAAA;AAKJ;AAJI;EACE,UAAA;EACA,YAAA;EACA,YAAA;AAMN;;AADA;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;AAIF;AAHE;EACE,cAAA;AAKJ;AAHE;EACE,cAAA;EACA,gCAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;AAKJ;;AAFA;EACE,yBAAA;EACA,WAAA;EACA,qCAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,+BAAA;EACA,WAAA;AAKF;;AAFE;EACE,UAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;AAKJ;;AAFA;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;AAKF;AAJE;EACE,cAAA;EACA,cAAA;EACA,gCAAA;EACA,gBAAA;EACA,kBAAA;EACA,gCAAA;EACA,eAAA;AAMJ;AAJE;EACE,eAAA;AAMJ;;AAHA;EACE,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;AAMF;;AAJA;EACE,UAAA;EACA,mBAAA;AAOF;;AALA;EACE,aAAA;EACA,WAAA;EACA,cAAA;EACA,4BAAA;EACA,sBAAA;AAQF;AAPE;EACE,SAAA;EACA,aAAA;EACA,mBAAA;AASJ;AARI;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,0CAAA;EACA,+BAAA;AAUN;AARI;EACE,kBAAA;AAUN;AATM;EACE,WAAA;EACA,YAAA;EACA,uBAAA;AAWR;AAPE;EACE,SAAA;AASJ;AARI;EACE,cAAA;EACA,gCAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,gCAAA;AAUN;AARI;EACE,kBAAA;EACA,qCAAA;EACA,cAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AAUN;;AALA;EACE,WAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAQF;AAPE;EACE,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,qCAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,+BAAA;AASJ;;AANA;EACE,cAAA;EACA,kBAAA;AASF;AARE;EACE,cAAA;EACA,qBAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,0BAAA;EACA,sBAAA;AAUJ;AATI;EACE,qBAAA;AAWN;;AANA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;AASF;;AAPA;EACE,WAAA;AAUF;;AARA;EACE,WAAA;AAWF;;AATA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;AAYF;;AAVA;EAEE;IACE,sBAAA;IACA,kBAAA;EAYF;EAVI;IACE,gBAAA;IACA,cAAA;EAYN;EATE;IACE,SAAA;IACA,mBAAA;EAWJ;EARA;IACE,8BAAA;EAUF;EATE;IACE,mBAAA;EAWJ;EARA;IACE,WAAA;IACA,aAAA;IACA,uBAAA;EAUF;AACF;AARA;EACE;IACE,cAAA;EAUF;EARA;IACE,kBAAA;EAUF;EARA;IACE,cAAA;EAUF;AACF;AARA;EAGE,gBAAA;AAQF;AAPE;EACE,YAAA;AASJ;AANE;EACE,aAAA;AAQJ;AANE;EACE,gBAAA;AAQJ;AAPI;EACE,cAbO;EAcP,gCAAA;AASN;AAPI;;EAEE,cAlBO;AA2Bb;AAPI;EACE,gBAAA;EACA,+BAAA;AASN;AAPI;EACE,iCAAA;AASN;AAvWQ;EAAA;IAAA;EAuWR;AAAA;AAvWQ;EAAA;IAAA;EAuWR;EAvWQ;IAAA;EAuWR;EAvWQ;IAAA;EAuWR;EAvWQ;IAAA;EAuWR;EAvWQ;IAAA;EAuWR;EAvWQ;IAAA,eAuWR;IAvWQ;EAuWR;AAAA","sourcesContent":["@import url(\"https://fonts.googleapis.com/css?family=Roboto+Mono:300,400|Rubik:900&display=swap\");\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@keyframes glowing {\n  from {\n    text-shadow: -1px 0px 3px rgba(255, 255, 255, 0.4);\n  }\n  to {\n    text-shadow: -1px 0px 6px rgba(255, 255, 255, 0.8);\n  }\n}\nbody {\n  margin: 0 auto;\n  width: 100%;\n  height: 100%;\n  background-color: #2b2b2b;\n}\nsection {\n  position: relative;\n  max-width: 2000px;\n  margin: 0 auto;\n}\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n\n.App.light {\n  background: #fff;\n}\n\n.down-arrow {\n  position: absolute;\n  font-size: 46px;\n  left: 48%;\n  transform: translateX(-50%);\n  bottom: 4px;\n}\n.intro {\n  position: relative;\n  width: 100%;\n  height: 100vh;\n  background: #000;\n  .down-arrow {\n    color: white;\n  }\n  h1 {\n    position: relative;\n    color: white;\n    font-family: \"Rubik\", sans-serif;\n    font-weight: 900;\n    font-size: 55px;\n    margin: 0px;\n    animation: glowing;\n    animation-duration: 1s;\n    animation-delay: 2s;\n    animation-direction: alternate;\n    animation-iteration-count: infinite;\n  }\n  h2 {\n    position: relative;\n    color: white;\n    font-family: \"Roboto Mono\", monospace;\n    margin: 5px auto;\n    font-size: 25px;\n  }\n}\n#cta_links {\n  a {\n    display: inline-block;\n    margin-right: 10px;\n    margin-left: 2px;\n    color: #3b3a36;\n    font-size: 30px;\n    transition: transform 0.3s;\n    will-change: transform;\n    &:hover {\n      transform: scale(1.1);\n    }\n  }\n  svg {\n    vertical-align: top;\n  }\n}\n.arrow-container {\n  -webkit-animation-delay: 5s;\n  clear: both;\n}\nsection.intro {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  .text-wrapper {\n    text-align: center;\n  }\n  .img-wrapper {\n    padding: 0 0 0 80px;\n    > img {\n      opacity: 1;\n      width: 180px;\n      height: auto;\n    }\n  }\n}\n\nsection.skills {\n  padding-top: 10vh;\n  position: relative;\n  background: #fff;\n  .down-arrow {\n    color: #3b3a36;\n  }\n  h1 {\n    color: #3b3a36;\n    font-family: \"Rubik\", sans-serif;\n    font-weight: 900;\n    text-align: center;\n    padding-bottom: 20px;\n  }\n}\n.skill {\n  background-color: #c0dfd9;\n  color: #fff;\n  font-family: \"Roboto Mono\", monospace;\n  display: inline-block;\n  padding: 11px 20px;\n  margin: 4px 4px;\n  border-radius: 15px;\n  box-shadow: 0px 3px 5px #b3c2bf;\n  float: left;\n}\n.skills {\n  ul {\n    width: 65%;\n    height: 65vh;\n    margin: 0 auto;\n    padding-left: 5%;\n  }\n}\nsection.projects {\n  position: relative;\n  background: #fff;\n  padding: 0 0 40px 0;\n  h1 {\n    margin: 0 auto;\n    color: #3b3a36;\n    font-family: \"Rubik\", sans-serif;\n    font-weight: 900;\n    text-align: center;\n    text-shadow: 4px 4px 4px #e9ece5;\n    font-size: 65px;\n  }\n  > h1 {\n    padding: 40px 0;\n  }\n}\n.project-container {\n  position: relative;\n  opacity: 0;\n  transform: scale(0);\n  transition: all 1s;\n}\n.project-container.in {\n  opacity: 1;\n  transform: scale(1);\n}\n.project-section {\n  display: flex;\n  width: 100%;\n  margin: 0 auto;\n  padding: 60px 40px 85px 40px;\n  box-sizing: border-box;\n  .left {\n    flex: 2;\n    display: flex;\n    align-items: center;\n    img {\n      width: 100%;\n      height: auto;\n      max-height: 100%;\n      border-radius: 10px;\n      border: 1px solid rgba(233, 236, 229, 0.4);\n      box-shadow: 0px 4px 4px #e9ece5;\n    }\n    .imageWrapper {\n      text-align: center;\n      img {\n        width: 100%;\n        height: auto;\n        background-color: white;\n      }\n    }\n  }\n  .right {\n    flex: 3;\n    h1 {\n      color: #3b3a36;\n      font-family: \"Rubik\", sans-serif;\n      font-size: 45px;\n      font-weight: bold;\n      text-align: center;\n      text-shadow: 4px 4px 4px #e9ece5;\n    }\n    p {\n      text-align: center;\n      font-family: \"Roboto Mono\", monospace;\n      color: #3b3a36;\n      width: 90%;\n      margin: 0 auto;\n      padding: 10px 0;\n      line-height: 1.4em;\n    }\n  }\n}\n\nul.skills {\n  width: 100%;\n  margin: 0 auto;\n  padding: 10px 0;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n  list-style: none;\n  > li {\n    padding: 5px 15px;\n    background-color: #c0dfd9;\n    color: #fff;\n    font-family: \"Roboto Mono\", monospace;\n    padding: 7px 15px;\n    margin: 4px 4px;\n    border-radius: 15px;\n    white-space: nowrap;\n    box-shadow: 0px 3px 5px #b3c2bf;\n  }\n}\n.links {\n  display: block;\n  text-align: center;\n  a {\n    color: #3b3a36;\n    display: inline-block;\n    padding: 10px;\n    font-size: 40px;\n    text-align: center;\n    transition: transform 0.3s;\n    will-change: transform;\n    &:hover {\n      transform: scale(1.1);\n    }\n  }\n}\n\nbutton.dark-mode-toggle {\n  position: fixed;\n  height: 35px;\n  width: 35px;\n  bottom: 15px;\n  right: 15px;\n  padding: 0;\n  margin: 0 auto;\n  border: none;\n  outline: none;\n  background: none;\n  border-radius: 50%;\n}\nbutton.dark-mode-toggle.light {\n  color: #000;\n}\nbutton.dark-mode-toggle.dark {\n  color: #fff;\n}\nbutton.dark-mode-toggle svg {\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  height: 100%;\n  width: 100%;\n  padding: 7px;\n  box-sizing: border-box;\n}\n@media screen and (max-width: 900px) {\n\n  .project-section {\n    flex-direction: column;\n    padding: 30px 40px;\n    .left {\n      img {\n        max-width: 620px;\n        margin: 0 auto;\n      }\n    }\n    .right {\n      flex: 1;\n      padding: 30px 0 0 0;\n    }\n  }\n  section.intro {\n    flex-direction: column-reverse;\n    .img-wrapper {\n      padding: 0 0 20px 0;\n    }\n  }\n  ul.skills {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n  }\n}\n@media screen and (max-width: 480px) {\n  section.projects h1 {\n    font-size: 3em;\n  }\n  .project-section {\n    padding: 30px 20px;\n  }\n  .project-section .right h1 {\n    font-size: 2em;\n  }\n}\n.App.dark {\n  $offWhite: #f7f7f7;\n  $grayShadow: #3b3b3b;\n  background: #000;\n  section.intro .img-wrapper {\n    opacity: 0.1;\n  }\n\n  .arrow-container {\n    display: none;\n  }\n  section.projects {\n    background: #000;\n    h1 {\n      color: $offWhite;\n      text-shadow: 4px 4px 4px $grayShadow;\n    }\n    p,\n    a {\n      color: $offWhite;\n    }\n    ul.skills > li {\n      background: #000;\n      box-shadow: 0px 0px 8px #f7f7f7;\n    }\n    .left img {\n      box-shadow: -2px 4px 15px #f7f7f7;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
